<template>
  <div class="node">
    <div style="border-radius: 10px; border: 1px solid #b5b5b5; background-color: white">
      <v-layout wrap align-center>
        <v-flex shrink class="pa-2">
          <v-btn icon @click="showMore = !showMore">
            <v-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</v-icon>
          </v-btn>
          Level {{ reasonRoute.level }}</v-flex
        >

        <v-flex class="pa-2">
          <template v-if="isEdit">
            <v-text-field
              id="title"
              v-validate="'required'"
              outline
              :value="reasonRoute.title"
              :name="`reason_item_${timestamp}`"
              :data-vv-name="`reason_item_${timestamp}`"
              data-vv-as="Title"
              single-line
              dense
              :hide-details="!errors.has(`reason_item_${timestamp}`)"
              :error="errors.has(`reason_item_${timestamp}`)"
              :error-messages="errors.first(`reason_item_${timestamp}`)"
              @input="handleUpdateReasonRoute({ title: $event })"
            ></v-text-field>
          </template>
          <template v-else>
            {{ reasonRoute.title }}
          </template>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <template v-if="isEdit">
            <v-btn icon color="primary" @click="showAddReasonRoute = true">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="handleDeleteReasonRoute">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showAddReasonRoute" max-width="500">
        <template v-if="showAddReasonRoute">
          <ReasonRouteManage
            :reason-route="reasonRoute"
            @onClose="showAddReasonRoute = false"
            @onSave="handleAddReasonRoute"
          />
        </template>
      </v-dialog>
    </div>
    <template v-if="showMore">
      <div
        v-if="reasonRoute.subReason.length == 0"
        class="text-xs-center py-2"
        style="font-size: 18px"
      >
        {{ $t('no_data') }}
      </div>
      <template v-else>
        <template v-for="(subReason, sindex) in reasonRoute.subReason">
          <SubReasonRoute
            :key="`sublevel_${parentKey}_${sindex}`"
            :parent-key="`${parentKey}_${sindex}`"
            :reason-route="subReason"
            :is-edit="isEdit"
            @updateReasonRoute="handleUpdateParentReasonRoute(sindex, $event)"
            @updateSubReasonRoute="handleUpdateSubReasonRoute"
            @onDeleteReasonRoute="handleDeleteSubReasonRoute(sindex)"
          />
        </template>
      </template>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import ReasonRouteManage from './ReasonRouteManage.vue'
export default {
  name: 'ReasonRoute',
  components: {
    ReasonRouteManage,
    SubReasonRoute: () => import('@/components/view/template/ticket/Reason/ReasonRoute')
  },
  inject: ['$validator'],
  props: {
    reasonRoute: {
      type: Object,
      default: () => {}
    },
    parentKey: {
      type: [String, Number],
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMore: false,
      showAddReasonRoute: false,
      timestamp: moment().valueOf()
    }
  },
  methods: {
    handleAddReasonRoute(data) {
      const reasonRoute = { ...this.reasonRoute }
      reasonRoute.subReason.push({
        ...data,
        level: this.reasonRoute.level + 1,
        name: `level_${this.reasonRoute.level + 1}`
      })
      this.$emit('updateReasonRoute', reasonRoute)

      this.showAddReasonRoute = false
    },
    handleUpdateReasonRoute(data) {
      this.$emit('updateReasonRoute', { ...this.reasonRoute, ...data })
    },
    handleUpdateParentReasonRoute(index, data) {
      const reasonRoute = { ...this.reasonRoute }
      reasonRoute.subReason[index] = data
      this.$emit('updateReasonRoute', reasonRoute)
    },
    handleUpdateSubReasonRoute(data) {
      this.$emit('updateReasonRoute', {
        ...this.reasonRoute,
        subReason: [...this.reasonRoute.subReason, data]
      })
    },
    handleDeleteReasonRoute() {
      this.$emit('onDeleteReasonRoute')
    },
    handleDeleteSubReasonRoute(index) {
      const reasonRoute = { ...this.reasonRoute }
      reasonRoute.subReason.splice(index, 1)
      this.$emit('updateReasonRoute', {
        ...reasonRoute
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Reason/ReasonRoute.vue